import { v4 as uuidv4 } from 'uuid';

import {
  ITAppAddressArgs,
  ITAppEmailArgs,
  ITAppPhoneArgs, ITAppThirdPartyIdArgs,
  TAppAddress,
  TAppEmail,
  TAppPhone, TAppThirdPartyId
} from 'TProtocol/common/models';

export class UAppAddress extends TAppAddress {
  public _key?: string;
  constructor(args?: ITAppAddressArgs) {
    super(args);
    this._key = uuidv4();
  }
}

export class UAppEmail extends TAppEmail {
  public _key?: string;
  constructor(args?: ITAppEmailArgs) {
    super(args);
    this._key = uuidv4();
  }

}

export class UAppPhone extends TAppPhone {
  public _key?: string;
  constructor(args?: ITAppPhoneArgs) {
    super(args);
    this._key = uuidv4();
  }
}

export class UAppThirdPartyId extends TAppThirdPartyId {
  public _key?: string;
  constructor(args?: ITAppThirdPartyIdArgs) {
    super(args);
    this._key = uuidv4();
  }
}
